import { useEffect } from 'react'
import {
  useGetNoticeListQuery,
  usePostNoticeCheckMutation,
} from '../../../api/rtk-query/loungeBoardApi'
import { LOUNGE_BOARD_SERVICE_TYPE } from '../loungeBoardContants'
import LoungeBoardNoticeItem from './LoungeBoardNoticeItem'
import PropTypes from 'prop-types'
import { noop } from 'lodash'

const LoungeBoardNoticeLayer = ({ onClose = noop }) => {
  const {
    data = { list: [] },
    isFetching,
    isSuccess,
    isError,
    refetch,
  } = useGetNoticeListQuery(undefined, {
    refetchOnFocus: true,
  })
  const [mutate] = usePostNoticeCheckMutation()

  useEffect(() => {
    if (isSuccess) {
      mutate()
    }
  }, [isSuccess, mutate])

  return (
    <div className="layer_notice">
      <div className="inner_notice">
        <div className="ly_head">
          <strong className="tit_service">공지사항</strong>
          <a
            className="link_util"
            href={`${process.env.REACT_APP_LOUNGE_BOARD_HOST}/bulletin/list?serviceType=${LOUNGE_BOARD_SERVICE_TYPE}`}
            rel="noopener noreferrer"
            target="_blank"
            onClick={onClose}>
            전체보기<span className="ico_outlink">바로가기</span>
          </a>
        </div>
        <div className="ly_body">
          {isFetching ? (
            <div className="cont_tab">
              <strong className="screen_out">공지사항 리스트</strong>
              <div className="group_loading">
                <span className="item_loading">
                  <span className="screen_out">로딩중</span>
                </span>
              </div>
            </div>
          ) : isError ? (
            <div className="cont_error">
              <div className="inner_error">
                <button
                  type="button"
                  className="btn_refresh"
                  disabled={isFetching}
                  onClick={refetch}>
                  <span className="ico_gnb ico_refresh">새로고침</span>
                </button>
                <p className="txt_error">데이터를 불러오지 못했습니다.</p>
              </div>
            </div>
          ) : data.list.length === 0 ? (
            <div className="cont_error">
              <div className="inner_error">
                <p className="txt_error">등록된 공지사항이 없습니다.</p>
              </div>
            </div>
          ) : (
            <div className="cont_tab">
              <strong className="screen_out">공지사항 리스트</strong>
              <ul className="list_alarm">
                {data.list.map(item => (
                  <LoungeBoardNoticeItem
                    key={item.id}
                    {...item}
                    onClose={onClose}
                  />
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
LoungeBoardNoticeLayer.propTypes = {
  onClose: PropTypes.func,
}
export default LoungeBoardNoticeLayer
